import type { Theme } from "@material-ui/core";

/**
 * Chrome greys and money colours the invoice card design names that have no
 * `theme.palette` equivalent — `palette.grey` is stock MUI (#EEEEEE/#E0E0E0/…),
 * so these cannot be read off the theme. Every colour that *does* have a
 * palette key (primary, brand, success, warning, error, text.primary,
 * text.secondary, background.paper) is read off the theme instead of listed
 * here.
 */
export const INVOICE_CARD_COLORS = {
  border: "#E4E7E9",
  divider: "#EEF0F2",
  altSurface: "#FAFBFB",
  pageTrack: "#F4F6F7",
  coveredTint: "#F2FBFC",
  insurerBadge: "#E3F7F9",
  paidBadge: "#E8FAEE",
  pillBorder: "#B7DCE7",
  pillHover: "#E6F5FA",
  paidText: "#00A03B",
  mutedBody: "#4A5157",
} as const;

export const INVOICE_CARD_RADIUS = {
  card: 10,
  inner: 8,
  pill: 999,
  swatch: 2,
} as const;

export const INVOICE_CARD_SHADOW = "0 1px 2px rgba(0, 0, 0, 0.06)";

export const INVOICE_CARD_ACCENT_BAR_WIDTH = 3;

export const INVOICE_CARD_BORDER_WIDTH = 1;

export type InvoicePayerKind = "insurer" | "self-pay";

export const invoiceAccentColor = (
  theme: Theme,
  payerKind: InvoicePayerKind,
): string =>
  payerKind === "insurer"
    ? theme.palette.brand.main
    : theme.palette.primary.main;

export const invoiceAmountColor = (
  theme: Theme,
  payerKind: InvoicePayerKind,
): string =>
  payerKind === "insurer"
    ? theme.palette.brand.main
    : theme.palette.text.primary;

export const invoiceRowBackgroundColor = (
  theme: Theme,
  payerKind: InvoicePayerKind,
): string =>
  payerKind === "insurer"
    ? INVOICE_CARD_COLORS.coveredTint
    : theme.palette.background.paper;
